import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { History, RotateCcw } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const DokumentSpuren = ({ teilnehmerId, onRestored }) => {
  const [liste, setListe] = useState(null);
  const laden = () => axios.get(`${API}/teilnehmer/${teilnehmerId}/dokument-spuren`).then((r) => setListe(r.data)).catch(() => setListe([]));
  const zurueck = async (s) => {
    try {
      await axios.post(`${API}/teilnehmer/${teilnehmerId}/dokument-spuren/wiederherstellen`, { quelle: s.quelle, id: s.id });
      toast.success(`„${s.filename}“ wiederhergestellt`);
      laden();
      onRestored?.();
    } catch (e) { toast.error(e.response?.data?.detail || "Wiederherstellen fehlgeschlagen"); }
  };
  if (!liste) {
    return (
      <button onClick={laden} className="inline-flex items-center gap-1.5 text-xs text-stone-600 hover:text-stone-900" data-testid="dok-spuren-btn">
        <History size={13} /> Gelöschte, archivierte und Kurs-Dokumente anzeigen
      </button>
    );
  }
  return (
    <div className="rounded-xl border border-stone-200 bg-stone-50 p-3" data-testid="dok-spuren">
      <p className="text-xs font-semibold uppercase tracking-wider text-stone-500 mb-2">Weitere Spuren ({liste.length})</p>
      {!liste.length && <p className="text-sm text-stone-500">Keine gelöschten, archivierten oder Kurs-Dokumente.</p>}
      <ul className="divide-y divide-stone-200">
        {liste.map((s) => (
          <li key={`${s.quelle}-${s.id}`} className="py-2 flex items-center justify-between gap-3 text-sm">
            <div className="min-w-0">
              <p className="font-medium text-stone-900 truncate">{s.filename} <span className="text-stone-500 font-normal">· {s.kategorie_label}</span></p>
              <p className="text-xs text-stone-500">{s.hinweis}{s.datum ? ` · ${new Date(s.datum).toLocaleString("de-DE")}` : ""}</p>
            </div>
            {["geloescht", "archiv"].includes(s.quelle) && (
              <button onClick={() => zurueck(s)} className="inline-flex items-center gap-1 text-xs font-medium text-[#B4502F] hover:underline shrink-0" data-testid={`dok-spur-restore-${s.id}`}>
                <RotateCcw size={12} /> Wiederherstellen
              </button>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};
